<div
  class="bulk-item-list__items"
  role="group"
  tabindex="0"
  [attr.aria-label]="listLabel"
  [attr.data-testid]="testIdPrefix ? testIdPrefix + '-items' : null"
>
  <div
    class="bulk-item-list__item"
    *ngFor="let detail of rows"
    [attr.data-testid]="testIdPrefix ? testIdPrefix + '-item' : null"
  >
    <span class="bulk-item-list__item-site">{{
      detail?.site?.siteNumber == null ? "" : "#" + detail.site.siteNumber
    }}</span>
    <span class="bulk-item-list__item-product">{{ rowTitle(detail) }}</span>
    <span class="bulk-item-list__item-when">
      <ng-container *ngIf="rowDueDate(detail) as due; else noDueDate">
        by {{ due | date : "MM/dd/yyyy" : locale }}
      </ng-container>
      <ng-template #noDueDate
        ><ng-container *ngIf="turnTimeFallback">{{ rowTurnTime(detail) }} days</ng-container></ng-template
      >
    </span>
    <span
      class="bulk-item-list__item-price"
      [attr.data-testid]="testIdPrefix ? testIdPrefix + '-item-price' : null"
      >{{ detail?.proposal?.bid | currency : "USD" : "symbol" : "1.0-0" }}</span
    >
  </div>
</div>
<div class="bulk-item-list__total" [attr.data-testid]="testIdPrefix ? testIdPrefix + '-total' : null">
  <span class="bulk-item-list__total-label">Total</span>
  <span class="bulk-item-list__total-value">{{
    totalPrice | currency : "USD" : "symbol" : "1.0-0"
  }}</span>
</div>
